import * as React from 'react';

import { alpha } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import ToolbarMUI from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';

import { visuallyHidden } from '@mui/utils';
import Service from '../../../util/Service';
import { Backdrop, CircularProgress } from '@mui/material';
import SearchField from '../../util/SearchField';
import ConfirmDialog from '../../common/ConfirmDialog';
import EditarPortalComp from './EditarPortalComp';
import TablePortalDeleteComp from './TablePortalDeleteComp';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {    
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        id: 'nome',
        align: 'center',
        disablePadding: true,
        label: 'Nome',
    },
    {
        id: 'titulo',
        align: 'center',
        disablePadding: true,
        label: 'Titulo',
    },
    {
        id: 'dtCriacao',
        align: 'center',
        disablePadding: true,
        label: 'Data de Criação',
    },
    {
        id: 'rules',
        align: 'right',
        disablePadding: false,
        label: 'Acesso',
    }
];

export default function TablePortal(props) {
    const { tituloPagina, disableFilter, update } = props;
    const navigate = useNavigate();

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState({});
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [todos, setTodos] = React.useState();
    const [rows, setRows] = React.useState([]);
    const [modoEdicao, setModoEdicao] = React.useState(false);
    const [modoNovaPagina, setModoNovaPagina] = React.useState(false);
    // const [tipo, setTipo] = React.useState('pagina')
    // const [index, setIndex] = React.useState(0)
    // const [estilo, setEstilo] = React.useState('')

    // const [openImg, setOpenImg] = React.useState(false);
    // const [openExt, setOpenExt] = React.useState(false);
    // const childRef = React.useRef(null);
    const [wait, setWait] = React.useState(false);

    // const [html, setHtml] = React.useState('');
    // const [blocks, setBlocks] = React.useState({
    //     time: new Date().getTime(),
    //     blocks: [],
    //     version: "2.1.0"
    // });
    // const [layout, setLayout] = React.useState({});
    // const [pagina, setPagina] = React.useState();
    // const [menu, setMenu] = React.useState();
    // const [nome, setNome] = React.useState();
    // const [titulo, setTitulo] = React.useState();
    // const [descricao, setDescricao] = React.useState();
    const [open, setOpen] = React.useState(false);

    const ref = React.useRef();

    React.useEffect(() => {
        buscaTodos();
    }, []);
    function buscaTodos() {
        setWait(true);
        const promise = Service.GET('/api/security/paginaHtml/findAllRestrito');        
        if( promise ){
            promise.then(r => {
                if( r.success === true || r.length > 0){
                    setTodos(r);
                    setRows(r);
                }else{
                    if( !localStorage.getItem("accessToken") ){
                        navigate('/loginPrimeiroAcesso');        
                    }
                }
                setWait(false);
            }).catch(e => {
                console.error(e);
                // navigate('/login');
            })
        }else{
            setWait(false);
            navigate('/loginPrimeiroAcesso');
        }
    }

    // React.useEffect(() => {
    //     if (modoNovaPagina) {
    //         setHtml('');
    //         setPagina({});
    //         setNome('');
    //         setTitulo('');
    //         setDescricao('');
    //         setMenu();
    //         setIndex(0);
    //         setTipo('pagina');
    //     }
    // }, [modoNovaPagina])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleClick = (event, item) => {
        (selected.id === item.id) ?
            setSelected({}) :
            setSelected(item);
    };

    const handleDoubleClick = (event, item) => {
        setSelected(item);
        setModoEdicao(true);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const visibleRows = React.useMemo(() =>
        [...rows]
            .sort(getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [order, orderBy, page, rowsPerPage, rows],);

    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
    
    function onSearch(txt) {        
        if( !txt || txt.length === 0 ){
            setRows( todos );
            return;
        }
        const arr = todos.filter( t =>{
            if( t.nome.toUpperCase().indexOf(txt.toUpperCase())>= 0){
                return true;
            }
            if( t.titulo && t.titulo.indexOf(txt)>= 0){
                return true;
            }
            if( t.descricao && t.descricao.indexOf(txt)>= 0){
                return true;
            }

            return false;
        });
        setRows( arr);
    }
    function handleExportClick() {
        Service.DOWNLOAD("/api/security/paginaHtml/export", "templatePortal.zip").then(ret => {
            console.log(ret);
        });
    }
    const handleImport = () => {
        const file = document.getElementById("file");
        file.click();
    }
    const upload = () => {
        let file = document.getElementById("file");
        let dados = new FormData();
        setWait(true);
        dados.append('file', file.files[0]);
        Service.UPLOAD("/api/security/paginaHtml/import", dados).then((result) => {
            
            if (result.success) {
                buscaTodos();
            } else {
                alert("Problema na importação: " + result.msg)
                setWait(false);
            }
        }).catch((e) => {
            setWait(false);
            // setMsg({ tipo: 'error', mensagem: e.message });
            console.error(e)
            alert(e.message);
        });
    }
    function fechar() {
        setModoEdicao(false);
        setModoNovaPagina(false);
        buscaTodos();
        if( update)update();
        // setLayout('portal');
        // setTipo('pagina');
        // setMenu();
        // setPagina();
        // setBlocks({
        //     time: new Date().getTime(),
        //     blocks: [],
        //     version: "2.1.0"
        // });
        // setCodigo();
    }
    if (modoEdicao || modoNovaPagina) {
        return (
            <EditarPortalComp 
                fechar={fechar} 
                modoEdicao={modoEdicao} 
                setModoEdicao={setModoEdicao} 
                selected={selected}
            />            
        )
    }
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                {/* <EnhancedTableToolbar numSelected={selected} /> */}
                {EnhancedTableToolbar(selected, onSearch, setModoEdicao, setModoNovaPagina, setOpen, handleImport, tituloPagina, disableFilter, buscaTodos)}
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected}
                            order={order}
                            orderBy={orderBy}
                            // onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {visibleRows && visibleRows.map((row, index) => {
                                const isItemSelected = (selected && selected.id == row.id);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <TableRow
                                        hover
                                        onClick={(event) => handleClick(event, row)}
                                        onDoubleClick={(event) => handleDoubleClick(event, row)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        selected={isItemSelected}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={isItemSelected}
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                        >
                                            {row.nome}
                                        </TableCell>
                                        <TableCell align="left">{row.titulo}</TableCell>
                                        <TableCell align="right">{formataData(row.dtCriacao)}</TableCell>
                                        <TableCell align="right">{row.rules ? 'Privado' : 'Publico'}</TableCell>
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label="Compacto"
            />
            <ConfirmDialog
                open={open}
                setOpen={setOpen}
                ok='Exportar'
                cancel="Sair"
                title="Exportar"
                body="Confirma exportar template. Isso pode levar alguns minutos"
                execute={handleExportClick}
            />
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={wait}
                onClick={() => setWait(false)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <input type="file" id="file" style={{ display: 'none' }} onChange={upload} accept="application/zip" />

        </Box>
    );
}
function EnhancedTableHead(props) {
    const { order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function EnhancedTableToolbar(item, onSearch, setModoEdicao, setModoNovaPagina, setOpen, handleImport, titulo, disableFilter, update) {
    function isEmpty() {
        if (!item) return true;
        let qtd = 0;
        for (let x in item) {
            qtd++;
        }
        return qtd > 0;
    }
    const empty = isEmpty();
    return (
        <ToolbarMUI
            sx={[
                {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                },
                item && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                },
            ]}
        >
            {empty ? (
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        color: "inherit",
                        flex: '1 1 100%'
                    }}>
                    {item.nome} - {item.descricao}
                </Typography>

            ) : (
                <React.Fragment>
                    <Typography
                        sx={{ flex: '1 1 100%' }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        {titulo ? titulo : 'Manutenção Portal'}
                    </Typography>
                    {(!disableFilter || disableFilter !== true) && <SearchField handleSearch={onSearch} />}
                </React.Fragment>
            )}
            {empty ? (
                <React.Fragment>
                    <Tooltip title="Nova Pagina">
                        <IconButton onClick={() => setModoNovaPagina(true)}>
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar">
                        <IconButton onClick={() => setModoEdicao(true)}>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                    <TablePortalDeleteComp pagina={item} action={update}/>
                    
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Tooltip title="Importar Template">
                        <IconButton onClick={handleImport}>
                            <UploadIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Exportar como template">
                        <IconButton onClick={() => setOpen(true)}>
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Nova Pagina">
                        <IconButton onClick={() => setModoNovaPagina(true)}>
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
            )}
        </ToolbarMUI>
    );
}